import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../api/firebase";
import {
  doc,
  onSnapshot,
  updateDoc,
  serverTimestamp,
  arrayUnion,
  Timestamp,
} from "firebase/firestore";

const YaeInvitationPage = () => {
  const [user, setUser] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const [hasYaeAccess, setHasYaeAccess] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        const uid = currentUser.uid;
        const userRef = doc(db, "users", uid);
        onSnapshot(userRef, (docSnap) => {
          const userData = docSnap.data();
          setUser(userData);
          const alreadyHasPhase3 = userData?.payments?.some(
            (p) => p.paymentPhase === "3"
          );
          setHasYaeAccess(alreadyHasPhase3);
        });
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // Firestore のユーザー情報をリアルタイム取得
  useEffect(() => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const userRef = doc(db, "users", currentUser.uid);
    const unsubscribe = onSnapshot(userRef, (doc) => {
      if (doc.exists()) {
        setUser({ uid: currentUser.uid, ...doc.data() });
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // 2期参加者でない場合は /home にリダイレクト
  useEffect(() => {
    if (user && !user.payments?.some((p) => p.paymentPhase === "2")) {
      navigate("/home");
    }
  }, [user, navigate]);

  const handleJoinClick = async () => {
    const currentUser = auth.currentUser;

    if (!currentUser) {
      alert("ログインが必要です");
      return;
    }

    const userRef = doc(db, "users", currentUser.uid);

    try {
      await updateDoc(userRef, {
        payments: arrayUnion({
          amountTotal: 0,
          paymentMethod: "2期無料招待",
          paymentPhase: "3",
          timestamp: Timestamp.now(), // ✅ 修正：JS側でタイムスタンプ生成
        }),
      });

      alert("無料招待が登録されました！");
    } catch (error) {
      console.error("登録エラー:", error);
      alert("無料招待の登録に失敗しました");
    }
  };

  if (!user) return <CircularProgress sx={{ mt: 5 }} />;

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      {/* 共感 */}
      <Box textAlign="center" mb={6}>
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          八重の誓い
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
          それは、自分と向き合う静かな旅路。
          <br />
          全国の仲間と共に、「内なる自分」と出会い直す、特別な時間。
        </Typography>
      </Box>

      <Divider sx={{ my: 4 }} />

      {/* 期待 */}
      <Box textAlign="center" mb={6}>
        <Typography variant="h5" fontWeight="medium" gutterBottom>
          今のあなたにこそ必要な、“誓い”
        </Typography>
        <Typography variant="body1">
          忙しい日々、心の声を後回しにしていませんか？
          <br />
          八重の誓いは、言葉と静寂の中で本当の自分と出会う体験です。
        </Typography>
      </Box>

      <Divider sx={{ my: 4 }} />

      {/* 応援 */}
      <Box textAlign="center" mb={6}>
        <Typography variant="h5" fontWeight="medium" gutterBottom>
          今なら無料ご招待のチャンス
        </Typography>
        <Typography variant="body1">
          本来なら¥ 51,500のプログラムですが2025年マスターマインドメンバーに参加された方は、
          <br />
          特別に無料招待をお送りしています。
        </Typography>
      </Box>

      <Box textAlign="center" mt={8}>
        {hasYaeAccess ? (
          <Typography variant="body1" color="primary" fontWeight="bold">
            あなたはすでに「八重の誓い」プロジェクトに参加されています。
          </Typography>
        ) : (
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={handleJoinClick}
          >
            無料招待を受ける
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default YaeInvitationPage;
